import { useState, useEffect } from "react";
import api from "../services/api";
import { ENDPOINTS } from "../utils/endpoints";
import { toast } from "react-toastify";

export const useCommunityForm = (editCommunityId) => {
  const [communityName, setCommunityName] = useState("");
  const [themeColor, setThemeColor] = useState("#3b0a59");
  const [hasLiveSession, setHasLiveSession] = useState(false);
  const [bannerFile, setBannerFile] = useState(null);
  const [iconFile, setIconFile] = useState(null);
  const [bannerPreview, setBannerPreview] = useState(null);
  const [iconPreview, setIconPreview] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [content, setContent] = useState({
    communityTitle: "",
    contentTitle: "",
    primaryText: "",
    secondaryText: "",
    contentBannerWebFile: null,
    contentBannerWebUrl: "",
    contentBannerAppFile: null,
    contentBannerAppUrl: "",
    contentImageWebFile: null,
    contentImageWebUrl: "",
    contentImageAppFile: null,
    contentImageAppUrl: "",
    deleteContentBannerWeb: false,
    deleteContentBannerApp: false,
    deleteContentImageWeb: false,
    deleteContentImageApp: false,
  });

  const handleBannerUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setBannerFile(file);
      setBannerPreview(URL.createObjectURL(file));
    }
  };

  const handleIconUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setIconFile(file);
      setIconPreview(URL.createObjectURL(file));
    }
  };

  const resetForm = () => {
    setCommunityName("");
    setThemeColor("#3b0a59");
    setHasLiveSession(false);
    setBannerPreview(null);
    setIconPreview(null);
    setContent({
      communityTitle: "",
      contentTitle: "",
      primaryText: "",
      secondaryText: "",
      contentBannerWebFile: null,
      contentBannerWebUrl: "",
      contentBannerAppFile: null,
      contentBannerAppUrl: "",
      contentImageWebFile: null,
      contentImageWebUrl: "",
      contentImageAppFile: null,
      contentImageAppUrl: "",
      deleteContentBannerWeb: false,
      deleteContentBannerApp: false,
      deleteContentImageWeb: false,
      deleteContentImageApp: false,
    });
  };

  const prefillFormForEdit = async () => {
    try {
      const { data } = await api.get(
        ENDPOINTS.GET_COMMUNITY_BY_ID(editCommunityId),
      );
      if (data.success) {
        const comm = data.community;

        setCommunityName(comm.name);
        setThemeColor(comm.theme_color);
        setHasLiveSession(comm.has_live_session === 1);
        setBannerPreview(`${ENDPOINTS.IMAGE_BASE_URL}${comm.banner}`);
        setIconPreview(`${ENDPOINTS.IMAGE_BASE_URL}${comm.icon}`);

        setContent({
          communityTitle: comm.community_title ?? "",
          contentTitle: comm.content_title ?? "",
          primaryText: comm.content_primary_text ?? "",
          secondaryText: comm.content_secondary_text ?? "",
          contentBannerWebFile: null,
          contentBannerWebUrl: comm.content_banner_web
            ? ENDPOINTS.IMAGE_BASE_URL + comm.content_banner_web
            : "",
          contentBannerAppFile: null,
          contentBannerAppUrl: comm.content_banner_app
            ? ENDPOINTS.IMAGE_BASE_URL + comm.content_banner_app
            : "",
          contentImageWebFile: null,
          contentImageWebUrl: comm.content_image_web
            ? ENDPOINTS.IMAGE_BASE_URL + comm.content_image_web
            : "",
          contentImageAppFile: null,
          contentImageAppUrl: comm.content_image_app
            ? ENDPOINTS.IMAGE_BASE_URL + comm.content_image_app
            : "",
          deleteContentBannerWeb: false,
          deleteContentBannerApp: false,
          deleteContentImageWeb: false,
          deleteContentImageApp: false,
        });

        return comm;
      }
    } catch (err) {
      console.error("Failed to load community", err);
      toast.error("Failed to load community data");
    }
  };

  useEffect(() => {
    if (editCommunityId !== null) {
      prefillFormForEdit();
    } else {
      resetForm();
    }
  }, [editCommunityId]);

  return {
    communityName,
    setCommunityName,
    themeColor,
    setThemeColor,
    hasLiveSession,
    setHasLiveSession,
    bannerFile,
    setBannerFile,
    iconFile,
    setIconFile,
    bannerPreview,
    iconPreview,
    handleBannerUpload,
    handleIconUpload,
    content,
    setContent,
    isSubmitting,
    setIsSubmitting,
    resetForm,
    prefillFormForEdit,
  };
};
